module.exports = __webpack_public_path__ + "static/media/kn95.bc3a8f41.png";